import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import pluralize from 'pluralize';
import { DropdownMenu, TextButton, Typography } from 'seagull';
import { ChevronDown } from 'seagull/icons';
import { getClientReminderTimes } from '~/business-logic/notificationSettings';
import { GetCadenceTimesDropdownTID } from './CadenceTimesDropdown.testIds';
export const CadenceTimesDropdown = (param)=>{
    let { times, onChange } = param;
    var _ref;
    const { CadenceTimesDropdownTestIds: testIds } = useMemo(()=>GetCadenceTimesDropdownTID(), []);
    const timesOptions = getClientReminderTimes();
    const triggerLabel = pluralize('time', (_ref = times !== null && times !== void 0 ? times : timesOptions[0]) !== null && _ref !== void 0 ? _ref : 1, true);
    return /*#__PURE__*/ _jsx(DropdownMenu, {
        hAlign: "left",
        maxHeight: "50%",
        target: /*#__PURE__*/ _jsx(TextButton, {
            weight: "bold",
            underline: "none",
            suffixIcon: /*#__PURE__*/ _jsx(ChevronDown, {}),
            bi: {
                name: 'cadence_times'
            },
            testId: testIds.Trigger(),
            children: triggerLabel
        }),
        children: timesOptions.map((option)=>/*#__PURE__*/ _jsx(DropdownMenu.Item, {
                bi: {
                    name: 'notification_cadence_times_option'
                },
                onClick: ()=>onChange(option),
                testId: testIds.Option(option),
                children: /*#__PURE__*/ _jsx(Typography, {
                    children: pluralize('time', option, true)
                })
            }, option))
    });
};
